<template>
  <v-container
    class="alert-container"
    ma-0
    pa-0
    fluid
  >
    <v-layout class="alert-layout align-center" :class="layoutClasses">
      <v-layout
        :class="stepIndicatorLayoutClass"
        :style="{
          zIndex: zIndex
        }"
      >
        <template>
          <v-progress-linear :value="currentStep/totalSteps * 100" />
        </template>
      </v-layout>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  VContainer,
  VLayout,
  VProgressLinear
} from 'vuetify/lib';
export default {
  components: {
    VContainer,
    VLayout,
    VProgressLinear
  },
  props: {
    totalSteps: {
      type: Number,
      required: true
    },
    currentStep: {
      type: Number,
      required: true
    },
    activeColor: {
      type: String,
      default: '#13abb1'
    },
    activeOpacity: {
      type: Number,
      default: 1
    },
    inactiveOpacity: {
      type: Number,
      default: 1
    },
    inactiveColor: {
      type: String,
      default: '#c5eaeb'
    },
    width: {
      type: String,
      default: '50px'
    },
    height: {
      type: String,
      default: '10px'
    },
    zIndex: {
      type: Number,
      default: 1
    },
    layoutClasses: {
      type: Array,
      default: () => ['py-2', 'my-2']
    },
    borderRadius: {
      type: String,
      default: '10px'
    }
  },
  computed: {
    ...mapGetters([
      'isInAppCampaign'
    ]),
    stepIndicatorLayoutClass(){
      return this.isInAppCampaign ? 'step-layout-xs-subsequent' : 'step-layout-xs';
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.step {
  margin: 0 4px 0 0;
  border-radius: 8px !important;
}

.step-layout-xs, .step-layout-xs-subsequent {
  padding-top: 1px !important;
}

@media(max-width:370px) {
   .step-layout-xs, .step-layout-xs-subsequent {
      margin: 2px 25px 0px 35px !important;
    }
}

.v-progress-linear{
  height: 5px !important;
  width: 96px !important;
  border-radius: 8px !important;
}

@media(min-width:600px){
  .v-progress-linear{
    width: 200px !important;
  }
}

</style>